export enum DataGridCellType {
	text = 'text',
	boolean = 'boolean',
	actionButton = 'actionButton',
	date = 'date',
	number = 'number',
	dateTime = 'dateTime',
	time = 'time',
	select = 'select',
	multiLanguage = 'multiLanguage',
	multiLanguageTextBox = 'multiLanguageTextBox',
	dateRange = 'dateRange',
	numberBox = 'numberBox',
	datePicker = 'datePicker',
	timePicker = 'timePicker',
	dateRangePicker = 'dateRangePicker',
	dateTimePicker = 'dateTimePicker'
}
